import { useState, useEffect } from 'react';

/**
 * Custom hook to poll Discord bot status every 30 minutes (2 times an hour).
 * @param {string} botHealthUrl - The HTTP health endpoint URL of your bot on Wispbyte
 */
export const useBotStatus = (botHealthUrl) => {
  const [isOnline, setIsOnline] = useState(true); // Default optimistic state
  const [loading, setLoading] = useState(true);
  const [botData, setBotData] = useState(null);

  useEffect(() => {
    if (!botHealthUrl) {
      setLoading(false);
      return;
    }

    const fetchStatus = async () => {
      try {
        const res = await fetch(botHealthUrl, { cache: 'no-store' });
        if (res.ok) {
          const data = await res.json();
          setIsOnline(data.status === 'online');
          setBotData(data);
        } else {
          setIsOnline(false);
        }
      } catch (err) {
        // If fetch fails or bot is unreachable (network error, CORS, JSON parse, etc.)
        if (process.env.NODE_ENV === 'development') console.warn('[useBotStatus] fetch error:', err);
        setIsOnline(false);
      } finally {
        setLoading(false);
      }
    };

    // Initial query on mount
    fetchStatus();

    // Re-query every 30 minutes (1,800,000 ms) = 2 times an hour
    const THIRTY_MINUTES_MS = 30 * 60 * 1000;
    const interval = setInterval(fetchStatus, THIRTY_MINUTES_MS);

    return () => clearInterval(interval);
  }, [botHealthUrl]);

  return { isOnline, loading, botData };
};
